module.exports = "/virtual-football-league/img/next-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/next-bck.png
// module id = 139
// module chunks = 4